import React from "react";
import axios from "axios";
import $ from "jquery";
import {
    removeNestedNullUndefined
} from './Utilities';

class GrantTypeahead extends React.Component {
	constructor(props){
        super(props);

        this.GrantField = React.createRef();
    }

    setFilter(obj){
    	this.props.filterData(obj.target.value);
    }

    render(){
    	return(
            <div className="mb-3">
                <input type="text" id="business-selector" className="form-control" 
                	   placeholder="Start typing the business name to filter..." 
                	   onChange={this.setFilter.bind(this)}
                	   ref={this.GrantField} />
            </div>    
    	);
    }

}

class GrantsPage extends React.Component {

	constructor(props){
        super(props);
        this.state = {
        	"businesses": {},
        	"matches": {},
        	"filter": ""
        };
    }

	componentDidMount(){
        this.getData();
    }

    getData(){
    	axios.get("PrivacyCenterPage_Controller/getOtherBusinessUnits?turnoffdebug=1")
                .then(response => this.formatData(response.data));
    }

    formatData(data){
    	this.setState({
    		businesses: data,			
    	});
    }

    filterData = (text) => {
    	var matches = $(this.state.businesses).filter(function(index, business){
            return business.Name.toLowerCase().includes(text.toLowerCase());
        });

        this.setState({
        	matches: matches.get(), //.get() removes any jquery functions from the object,
        	filter: text 
        });
    }
	
	render(){
		var businesses = {};
		var loading = true;
		if(Object.keys(this.state.matches).length > 0) {//matches found
			businesses = this.state.matches;
			loading = false;
		} else if (this.state.filter.length === 0){//default, not yet filtered
			businesses = this.state.businesses;
		} else if (this.state.filter.length > 0 && Object.keys(this.state.matches).length === 0){//filtered but no results
			loading = false;
		}

	
		if(Object.keys(businesses).length > 0){ 
			return(
				<div id="BusinessesHolder" className="row">
					<GrantTypeahead businesses={businesses} filterData={this.filterData.bind()} />

					{businesses.map((business, key) => {
						return(
							<div className="ol-sm-6 col-md-4 col-xl-4" key={key+business.ID}>
				                <a href={"privacycenter/customer/"+business.ID+"/"+business.ApplicationID+"/login"}>
				                    <div className="card">			                        <div className="text-center mt-3 px-1">
				                            <div className="avatar-lg rounded-circle bg-soft-secondary mx-auto">
				                                <i className="fas fa-broadcast-tower font-28 avatar-title text-secondary"></i>
				                            </div>
				                            <h5 className="mt-3">{business.Name}</h5>
				                            <div className="text-muted detail">
				                                <h5>Grant Access to {business.Name}</h5>
				                                <p>Allow this business to access your data and earn additional income.</p>
				                            </div>
				                        </div>
				                    </div>
				                </a>
				            </div>
			            );
			        })}  
		        </div>
		    ); 
		} else if (loading){
			return (
				<div id="BusinessesHolder" className="row">
					<GrantTypeahead businesses={businesses} filterData={this.filterData.bind()} />
					<div className="react-loading horizontal"></div>
				</div>
			);		
		} else {//empty result set
			return (
				<div id="BusinessesHolder" className="row">
					<GrantTypeahead businesses={businesses} filterData={this.filterData.bind()} />
					<p>No results</p>
				</div>
			);
		}
	}
}

export default GrantsPage;